<template>
  <div class="lots-list">
    <div
      v-if="displayAuctions"
      :class="gridClass"
      :style="gridStyle"
    >
      <template v-for="(lot, i) in auctions">
        <lot
          :key="lot.id"
          :auction="lot"
          :class="gridItemClass"
          :style="lotStyle(i)"
          :proportions="gridItemSize.proportions"
        />
      </template>
      <template v-for="i in emptySlots">
        <lot
          :key="`empty_${i}`"
          :class="gridItemClass"
          :style="emptyLotStyle(i - 1)"
          :proportions="gridItemSize.proportions"
        />
      </template>
    </div>
    <div
      v-if="displayEmpty"
      class="empty">
      <div class="empty__content">
        <img src="../assets/images/logo_car.png">
        <div class="empty__title">開催中のオークションは<br>ありません。</div>
        <div class="empty__subtitle">電話でのお問い合わせ</div>
        <div class="empty__phone"><a href="tel:0120989403">0120-989-403</a></div>
        <div class="empty__footer">
          <div>車を高く売るなら、楽天Car車買取！</div>
          <div>
            <a
              href="/"
              target="_blank"
            >{{ topPage }}</a>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="displayError"
      class="empty">
      <div class="empty__content">
        <img src="../assets/images/logo_car.png">
        <div class="empty__title">申し訳ありません。<br>データの読み込みに失敗しました。</div>
        <div class="empty__subtitle">電話でのお問い合わせ</div>
        <div class="empty__phone"><a href="tel:0120989403">0120-989-403</a></div>
        <div class="empty__footer">
          <div>車を高く売るなら、楽天Car車買取！</div>
          <div>
            <a
              href="/"
              target="_blank"
            >{{ topPage }}</a>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="displayLoading"
      class="empty">
      <div class="empty__content">
        <div class="progress">
          <loading-progress
            :indeterminate="true"
            :counter-clockwise="false"
            :hide-background="false"
            class="progress__circle"
            shape="circle"
            size="200"
            rotate
            fill-duration="2"
            rotation-duration="1"
          />
          <div class="progress__logo">
            <img src="../assets/images/logo_car.png">
          </div>
        </div>
        <div class="empty__title">
          読み込み中
          <br>
          しばらくお待ちください
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="stylus">
.lots-list
  .vue-progress-path
    .background
      stroke: rgba(#fff, 0.1)

    .progress
      stroke: rgba(#fff, 1)
</style>

<style lang="stylus" scoped>
progress-size = 200px
circle-padding = 25px
circle-size = progress-size + (circle-padding * 2)

.progress
  color: red
  height: progress-size
  margin: 0 auto (circle-padding * 2)
  position: relative
  width: progress-size

  &, &__circle, &__logo
    align-items: center
    display: flex
    justify-content: center

  &__circle, &__logo
    position: absolute

  &__circle
    height: circle-size
    left: 0 - circle-padding
    top: 0 - circle-padding
    width: circle-size

  &__logo
    height: 100%
    left: 0
    top: 0
    width: 100%

    img
      height: auto
      width: 60%
</style>

<script>
import sortBy from 'lodash/sortBy';
import SmartGrid from './mixins/SmartGrid';
import Lot from './Lot';

export default {
  components: {
    Lot,
  },
  mixins: [
    SmartGrid,
  ],
  props: {
    appointmentId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      topPage: window.location.hostname,
    };
  },
  computed: {
    gridSingle() {
      return !!this.appointmentId;
    },
    auctions() {
      const auctions = this.$store.state.auctions || [];

      if (this.appointmentId) {
        return auctions.filter(a => a.appointmentId === this.appointmentId);
      }

      return auctions.filter(a => a.isActive() || a.status === 'bids_confirm');
    },
    auctionsError() {
      return this.$store.state.auctionsStatus === 'error';
    },
    auctionsReady() {
      return this.$store.state.auctionsStatus === 'ready';
    },
    display() {
      if (this.auctionsError) return 'error';
      if (this.auctions.length || this.appointmentId) return 'auctions';
      if (this.auctionsReady) return 'empty';
      return 'loading';
    },
    displayAuctions() {
      return this.display === 'auctions';
    },
    displayEmpty() {
      return this.display === 'empty';
    },
    displayError() {
      return this.display === 'error';
    },
    displayLoading() {
      return this.display === 'loading';
    },
    sortedAuctions() {
      const auctions = this.auctions;
      return sortBy(auctions, (auction) => {
        let sort = '';

        if (auction.status === 'bids_confirm') {
          sort = `2${1 / auction.timeFinish}`;
        } else if (auction.isActive()) {
          sort = `0${1 / auction.id}`;
        } else {
          sort = `1${1 / auction.timeFinish}`;
        }

        return sort;
      });
    },
  },
  methods: {
    getLotSortIndex(i) {
      return this.sortedAuctions.indexOf(this.auctions[i]);
    },
    lotStyle(i) {
      const j = this.getLotSortIndex(i);
      if (j < 0) {
        return this.gridItemStyle(i);
      }
      return this.gridItemStyle(j);
    },
    emptyLotStyle(i) {
      return this.lotStyle(i + this.auctions.length);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LotsList.vue